import React from "react";
import classNames from "../../utils/classNames";

const noop = () => {};
const defaultProps = {
  type: "text",
  strict: false,
  onChange: noop,
};

function InputUsername({ className, strict, onChange, uppercase, ...props }) {
  function onInput(e) {
    const value = e.target.value;
    const character = value.charAt(value.length - 1);
    // only string
    if (strict && !/^[a-zA-Z]*$/.test(character)) {
      return;
    }
    if (uppercase) {
      e.target.value = value.toUpperCase();
    }
    onChange(e.target.value);
  }

  return (
    <div className="input-group">
      <span class="input-group-text">
        <i class="bi bi-person"></i>
      </span>
      <input
        className={classNames("form-control", className)}
        onInput={onInput}
        {...props}
      />
    </div>
  );
}

InputUsername.defaultProps = defaultProps;
export default InputUsername;
